// Generated by purs version 0.13.8
"use strict";
var Restaumatic_I18n = require("../Restaumatic.I18n/index.js");
var t = {
    actions: {
        back: Restaumatic_I18n.makeTranslationKey("actions.back"),
        cancel: Restaumatic_I18n.makeTranslationKey("actions.cancel")
    },
    activerecord: {
        attributes: {
            delivery_address: {
                address_line: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.address_line"),
                apt_number: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.apt_number"),
                apt_number_shortcut: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.apt_number_shortcut"),
                city: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.city"),
                floor: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.floor"),
                floor_shortcut: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.floor_shortcut"),
                label: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.label"),
                post_code: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.post_code"),
                street: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.street"),
                street_number: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.street_number"),
                street_number_short: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.delivery_address.street_number_short")
            },
            order: {
                cancel_reason: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.cancel_reason"),
                confirmation_code: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.confirmation_code"),
                corrected_total: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.corrected_total"),
                correction_reason: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.correction_reason"),
                deliver_at: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.deliver_at"),
                delivery_address: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.delivery_address"),
                delivery_method: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.delivery_method"),
                delivery_method_type: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.delivery_method_type"),
                info: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.info"),
                ordered_at: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.ordered_at"),
                ordering_method: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.ordering_method"),
                payment_method_type: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.payment_method_type"),
                print: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.print"),
                source: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.source"),
                state: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.state"),
                user: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.order.user")
            },
            user: {
                confirmation_token: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.confirmation_token"),
                email: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.email"),
                full_name: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.full_name"),
                id: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.id"),
                name: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.name"),
                parsed_phone: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.parsed_phone"),
                password: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.password"),
                phone: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.phone"),
                subscribed: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.subscribed"),
                surname: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.surname"),
                tos_agreement: Restaumatic_I18n.makeTranslationKey("activerecord.attributes.user.tos_agreement")
            }
        },
        errors: {
            models: {
                order: {
                    attributes: {
                        delivery_address: {
                            delivery_not_possible: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.delivery_address.delivery_not_possible")
                        },
                        user: {
                            attributes: {
                                email: {
                                    invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.user.attributes.email.invalid"),
                                    taken: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.user.attributes.email.taken")
                                },
                                full_name: {
                                    invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.user.attributes.full_name.invalid")
                                },
                                parsed_phone: {
                                    invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.user.attributes.parsed_phone.invalid")
                                }
                            }
                        },
                        vat_id: {
                            invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.attributes.vat_id.invalid")
                        }
                    },
                    invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.invalid"),
                    max_order_value: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.max_order_value"),
                    min_order_value: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.min_order_value"),
                    payment_failure: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.payment_failure"),
                    payment_too_late: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.payment_too_late"),
                    promotion_not_available: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.promotion_not_available"),
                    restaurant_is_closed: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.restaurant_is_closed"),
                    unavailable: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.order.unavailable")
                },
                pizza: {
                    attributes: {
                        base: {
                            blank: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.pizza.attributes.base.blank")
                        },
                        topping_ids: {
                            blank: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.pizza.attributes.topping_ids.blank")
                        },
                        toppings: {
                            blank: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.pizza.attributes.toppings.blank")
                        }
                    },
                    format: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.pizza.format")
                },
                user: {
                    attributes: {
                        email: {
                            invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.email.invalid"),
                            taken: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.email.taken")
                        },
                        full_name: {
                            invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.full_name.invalid")
                        },
                        parsed_phone: {
                            invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.parsed_phone.invalid")
                        },
                        password: {
                            blank: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.password.blank"),
                            too_short: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.password.too_short")
                        },
                        tos_agreement: {
                            invalid: Restaumatic_I18n.makeTranslationKey("activerecord.errors.models.user.attributes.tos_agreement.invalid")
                        }
                    }
                }
            }
        }
    },
    cart: {
        errors: {
            comboUnavailable: Restaumatic_I18n.makeTranslationKey("cart.errors.comboUnavailable"),
            invalidProductVariant: Restaumatic_I18n.makeTranslationKey("cart.errors.invalidProductVariant"),
            productCantBeOrdered: Restaumatic_I18n.makeTranslationKey("cart.errors.productCantBeOrdered"),
            productUnavailable: Restaumatic_I18n.makeTranslationKey("cart.errors.productUnavailable"),
            tooManyParts: Restaumatic_I18n.makeTranslationKey("cart.errors.tooManyParts")
        },
        packagingContainersCost: Restaumatic_I18n.makeTranslationKey("cart.packagingContainersCost")
    },
    coupon: {
        already_used: Restaumatic_I18n.makeTranslationKey("coupon.already_used"),
        fetch_error: Restaumatic_I18n.makeTranslationKey("coupon.fetch_error"),
        invalid: Restaumatic_I18n.makeTranslationKey("coupon.invalid")
    },
    coupon_promotion: {
        default_name: Restaumatic_I18n.makeTranslationKey("coupon_promotion.default_name")
    },
    date: {
        day: {
            abbr_names: {
                friday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.friday"),
                monday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.monday"),
                saturday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.saturday"),
                sunday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.sunday"),
                thursday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.thursday"),
                tuesday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.tuesday"),
                wednesday: Restaumatic_I18n.makeTranslationKey("date.day.abbr_names.wednesday")
            },
            names: {
                friday: Restaumatic_I18n.makeTranslationKey("date.day.names.friday"),
                monday: Restaumatic_I18n.makeTranslationKey("date.day.names.monday"),
                saturday: Restaumatic_I18n.makeTranslationKey("date.day.names.saturday"),
                sunday: Restaumatic_I18n.makeTranslationKey("date.day.names.sunday"),
                thursday: Restaumatic_I18n.makeTranslationKey("date.day.names.thursday"),
                tuesday: Restaumatic_I18n.makeTranslationKey("date.day.names.tuesday"),
                wednesday: Restaumatic_I18n.makeTranslationKey("date.day.names.wednesday")
            }
        }
    },
    delivery: {
        change_restaurant: Restaumatic_I18n.makeTranslationKey("delivery.change_restaurant"),
        checking_delivery: Restaumatic_I18n.makeTranslationKey("delivery.checking_delivery"),
        enter_address: Restaumatic_I18n.makeTranslationKey("delivery.enter_address"),
        geocoding: Restaumatic_I18n.makeTranslationKey("delivery.geocoding"),
        geocoding_error: Restaumatic_I18n.makeTranslationKey("delivery.geocoding_error"),
        not_possible: Restaumatic_I18n.makeTranslationKey("delivery.not_possible"),
        select_pickup: Restaumatic_I18n.makeTranslationKey("delivery.select_pickup")
    },
    delivery_method: {
        description: {
            delivery: Restaumatic_I18n.makeTranslationKey("delivery_method.description.delivery"),
            delivery_to_address: Restaumatic_I18n.makeTranslationKey("delivery_method.description.delivery_to_address"),
            dine_in: Restaumatic_I18n.makeTranslationKey("delivery_method.description.dine_in"),
            pickup: Restaumatic_I18n.makeTranslationKey("delivery_method.description.pickup"),
            select: Restaumatic_I18n.makeTranslationKey("delivery_method.description.select")
        },
        dine_in: Restaumatic_I18n.makeTranslationKey("delivery_method.dine_in"),
        dinein: Restaumatic_I18n.makeTranslationKey("delivery_method.dinein"),
        locate_me: Restaumatic_I18n.makeTranslationKey("delivery_method.locate_me"),
        no_contact_delivery: Restaumatic_I18n.makeTranslationKey("delivery_method.no_contact_delivery"),
        no_contact_delivery_choice: Restaumatic_I18n.makeTranslationKey("delivery_method.no_contact_delivery_choice"),
        no_contact_delivery_tooltip: Restaumatic_I18n.makeTranslationKey("delivery_method.no_contact_delivery_tooltip"),
        pickup: Restaumatic_I18n.makeTranslationKey("delivery_method.pickup"),
        shipment: Restaumatic_I18n.makeTranslationKey("delivery_method.shipment")
    },
    dish_settings: {
        fit: Restaumatic_I18n.makeTranslationKey("dish_settings.fit"),
        gluten_free: Restaumatic_I18n.makeTranslationKey("dish_settings.gluten_free"),
        lactose_free: Restaumatic_I18n.makeTranslationKey("dish_settings.lactose_free"),
        sea_food: Restaumatic_I18n.makeTranslationKey("dish_settings.sea_food"),
        spicy1: Restaumatic_I18n.makeTranslationKey("dish_settings.spicy1"),
        spicy2: Restaumatic_I18n.makeTranslationKey("dish_settings.spicy2"),
        spicy3: Restaumatic_I18n.makeTranslationKey("dish_settings.spicy3"),
        vegan: Restaumatic_I18n.makeTranslationKey("dish_settings.vegan"),
        vegetarian: Restaumatic_I18n.makeTranslationKey("dish_settings.vegetarian")
    },
    errors: {
        messages: {
            accepted: Restaumatic_I18n.makeTranslationKey("errors.messages.accepted"),
            already_confirmed: Restaumatic_I18n.makeTranslationKey("errors.messages.already_confirmed"),
            array_length_at_most: Restaumatic_I18n.makeTranslationKey("errors.messages.array_length_at_most"),
            at_least_one: Restaumatic_I18n.makeTranslationKey("errors.messages.at_least_one"),
            blank: Restaumatic_I18n.makeTranslationKey("errors.messages.blank"),
            cms: {
                liquid_syntax: Restaumatic_I18n.makeTranslationKey("errors.messages.cms.liquid_syntax")
            },
            confirmation: Restaumatic_I18n.makeTranslationKey("errors.messages.confirmation"),
            empty: Restaumatic_I18n.makeTranslationKey("errors.messages.empty"),
            equal_to: Restaumatic_I18n.makeTranslationKey("errors.messages.equal_to"),
            even: Restaumatic_I18n.makeTranslationKey("errors.messages.even"),
            exclusion: Restaumatic_I18n.makeTranslationKey("errors.messages.exclusion"),
            expired: Restaumatic_I18n.makeTranslationKey("errors.messages.expired"),
            extension_white_list_error: Restaumatic_I18n.makeTranslationKey("errors.messages.extension_white_list_error"),
            greater_than: Restaumatic_I18n.makeTranslationKey("errors.messages.greater_than"),
            greater_than_or_equal_to: Restaumatic_I18n.makeTranslationKey("errors.messages.greater_than_or_equal_to"),
            inclusion: Restaumatic_I18n.makeTranslationKey("errors.messages.inclusion"),
            invalid: Restaumatic_I18n.makeTranslationKey("errors.messages.invalid"),
            invalid_time_range: Restaumatic_I18n.makeTranslationKey("errors.messages.invalid_time_range"),
            later_than_start: Restaumatic_I18n.makeTranslationKey("errors.messages.later_than_start"),
            less_than: Restaumatic_I18n.makeTranslationKey("errors.messages.less_than"),
            less_than_or_equal_to: Restaumatic_I18n.makeTranslationKey("errors.messages.less_than_or_equal_to"),
            not_a_number: Restaumatic_I18n.makeTranslationKey("errors.messages.not_a_number"),
            not_an_integer: Restaumatic_I18n.makeTranslationKey("errors.messages.not_an_integer"),
            not_found: Restaumatic_I18n.makeTranslationKey("errors.messages.not_found"),
            not_locked: Restaumatic_I18n.makeTranslationKey("errors.messages.not_locked"),
            odd: Restaumatic_I18n.makeTranslationKey("errors.messages.odd"),
            present: Restaumatic_I18n.makeTranslationKey("errors.messages.present"),
            record_invalid: Restaumatic_I18n.makeTranslationKey("errors.messages.record_invalid"),
            taken: Restaumatic_I18n.makeTranslationKey("errors.messages.taken"),
            too_long: Restaumatic_I18n.makeTranslationKey("errors.messages.too_long"),
            too_short: Restaumatic_I18n.makeTranslationKey("errors.messages.too_short"),
            wrong_array_length: Restaumatic_I18n.makeTranslationKey("errors.messages.wrong_array_length"),
            wrong_length: Restaumatic_I18n.makeTranslationKey("errors.messages.wrong_length")
        }
    },
    first_order_discount: {
        validation: {
            alert: {
                confirm: Restaumatic_I18n.makeTranslationKey("first_order_discount.validation.alert.confirm"),
                content: Restaumatic_I18n.makeTranslationKey("first_order_discount.validation.alert.content"),
                warning: Restaumatic_I18n.makeTranslationKey("first_order_discount.validation.alert.warning")
            }
        },
        wizard: {
            claim_button: Restaumatic_I18n.makeTranslationKey("first_order_discount.wizard.claim_button"),
            coupon_denied: Restaumatic_I18n.makeTranslationKey("first_order_discount.wizard.coupon_denied"),
            coupon_sent: Restaumatic_I18n.makeTranslationKey("first_order_discount.wizard.coupon_sent"),
            header: Restaumatic_I18n.makeTranslationKey("first_order_discount.wizard.header"),
            send_button: Restaumatic_I18n.makeTranslationKey("first_order_discount.wizard.send_button")
        }
    },
    formtastic: {
        labels: {
            delivery_address: {
                additional_info: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.additional_info"),
                address_line: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.address_line"),
                apt_number: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.apt_number"),
                apt_number_shortcut: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.apt_number_shortcut"),
                block: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.block"),
                city: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.city"),
                floor: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.floor"),
                floor_shortcut: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.floor_shortcut"),
                house: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.house"),
                house_or_block: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.house_or_block"),
                interphone: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.interphone"),
                label: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.label"),
                post_code: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.post_code"),
                sector: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.sector"),
                staircase: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.staircase"),
                street: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.street"),
                street_number: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.street_number"),
                street_number_short: Restaumatic_I18n.makeTranslationKey("formtastic.labels.delivery_address.street_number_short")
            },
            order: {
                confirmation_code: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.confirmation_code"),
                create_invoice: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.create_invoice"),
                deliver_at: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.deliver_at"),
                delivery_method_type: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.delivery_method_type"),
                override_distance_check: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.override_distance_check"),
                payment_method_type: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.payment_method_type"),
                user_note: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.user_note"),
                vat_id: Restaumatic_I18n.makeTranslationKey("formtastic.labels.order.vat_id")
            }
        }
    },
    generic: {
        back: Restaumatic_I18n.makeTranslationKey("generic.back"),
        close: Restaumatic_I18n.makeTranslationKey("generic.close"),
        missing: Restaumatic_I18n.makeTranslationKey("generic.missing"),
        none: Restaumatic_I18n.makeTranslationKey("generic.none"),
        today: Restaumatic_I18n.makeTranslationKey("generic.today")
    },
    marketing_consents: {
        details: Restaumatic_I18n.makeTranslationKey("marketing_consents.details"),
        general_consent: Restaumatic_I18n.makeTranslationKey("marketing_consents.general_consent"),
        more: Restaumatic_I18n.makeTranslationKey("marketing_consents.more"),
        subscribe_email: Restaumatic_I18n.makeTranslationKey("marketing_consents.subscribe_email"),
        subscribe_phone: Restaumatic_I18n.makeTranslationKey("marketing_consents.subscribe_phone")
    },
    menu: {
        creator: {
            actions: {
                editModifier: Restaumatic_I18n.makeTranslationKey("menu.creator.actions.editModifier"),
                split: Restaumatic_I18n.makeTranslationKey("menu.creator.actions.split")
            },
            chooseProduct: Restaumatic_I18n.makeTranslationKey("menu.creator.chooseProduct"),
            defaultTitle: Restaumatic_I18n.makeTranslationKey("menu.creator.defaultTitle")
        },
        productTemporarilyUnavailable: Restaumatic_I18n.makeTranslationKey("menu.productTemporarilyUnavailable")
    },
    mobileApp: {
        actions: {
            changeRestaurant: Restaumatic_I18n.makeTranslationKey("mobileApp.actions.changeRestaurant")
        }
    },
    order: {
        already_assigned: Restaumatic_I18n.makeTranslationKey("order.already_assigned"),
        auto_cancel_reason: Restaumatic_I18n.makeTranslationKey("order.auto_cancel_reason"),
        correct_total_text: Restaumatic_I18n.makeTranslationKey("order.correct_total_text"),
        coupon: {
            errors: {
                online_payment: Restaumatic_I18n.makeTranslationKey("order.coupon.errors.online_payment")
            }
        },
        default_cancel_reason: Restaumatic_I18n.makeTranslationKey("order.default_cancel_reason"),
        delivery_address: Restaumatic_I18n.makeTranslationKey("order.delivery_address"),
        delivery_method: Restaumatic_I18n.makeTranslationKey("order.delivery_method"),
        description: Restaumatic_I18n.makeTranslationKey("order.description"),
        description_site: Restaumatic_I18n.makeTranslationKey("order.description_site"),
        expiry_cancel_reason: Restaumatic_I18n.makeTranslationKey("order.expiry_cancel_reason"),
        max_handling_time_exceeded: Restaumatic_I18n.makeTranslationKey("order.max_handling_time_exceeded"),
        name: Restaumatic_I18n.makeTranslationKey("order.name"),
        number: Restaumatic_I18n.makeTranslationKey("order.number"),
        payment_failed: Restaumatic_I18n.makeTranslationKey("order.payment_failed"),
        total: Restaumatic_I18n.makeTranslationKey("order.total"),
        total_correction: Restaumatic_I18n.makeTranslationKey("order.total_correction")
    },
    orderInfo: {
        pickupAtAddress: Restaumatic_I18n.makeTranslationKey("orderInfo.pickupAtAddress")
    },
    orders: {
        checkout: {
            agreement_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.agreement_html"),
            back_to_menu: Restaumatic_I18n.makeTranslationKey("orders.checkout.back_to_menu"),
            blik_code: Restaumatic_I18n.makeTranslationKey("orders.checkout.blik_code"),
            card: {
                code: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.code"),
                exp_date: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.exp_date"),
                invalidCVV: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.invalidCVV"),
                invalidCardData: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.invalidCardData"),
                invalidExpiration: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.invalidExpiration"),
                invalidNumber: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.invalidNumber"),
                month: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.month"),
                name: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.name"),
                number: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.number"),
                year: Restaumatic_I18n.makeTranslationKey("orders.checkout.card.year")
            },
            close_cart: Restaumatic_I18n.makeTranslationKey("orders.checkout.close_cart"),
            confirmation_code_error: Restaumatic_I18n.makeTranslationKey("orders.checkout.confirmation_code_error"),
            confirmation_code_missing_data: Restaumatic_I18n.makeTranslationKey("orders.checkout.confirmation_code_missing_data"),
            confirmation_code_sent: Restaumatic_I18n.makeTranslationKey("orders.checkout.confirmation_code_sent"),
            delivery_notes: Restaumatic_I18n.makeTranslationKey("orders.checkout.delivery_notes"),
            delivery_time_info_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.delivery_time_info_html"),
            load_error: Restaumatic_I18n.makeTranslationKey("orders.checkout.load_error"),
            loading: Restaumatic_I18n.makeTranslationKey("orders.checkout.loading"),
            main_guarantee2_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.main_guarantee2_html"),
            main_guarantee3_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.main_guarantee3_html"),
            main_guarantee4_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.main_guarantee4_html"),
            main_guarantee_html: Restaumatic_I18n.makeTranslationKey("orders.checkout.main_guarantee_html"),
            max_length: Restaumatic_I18n.makeTranslationKey("orders.checkout.max_length"),
            modal: {
                close: Restaumatic_I18n.makeTranslationKey("orders.checkout.modal.close"),
                payments: {
                    title: Restaumatic_I18n.makeTranslationKey("orders.checkout.modal.payments.title")
                },
                rules: {
                    title: Restaumatic_I18n.makeTranslationKey("orders.checkout.modal.rules.title")
                }
            },
            my_cart: Restaumatic_I18n.makeTranslationKey("orders.checkout.my_cart"),
            not_found: Restaumatic_I18n.makeTranslationKey("orders.checkout.not_found"),
            payment: {
                cash: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment.cash"),
                label: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment.label"),
                online: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment.online")
            },
            payment_channel: {
                required: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment_channel.required"),
                unable_to_load: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment_channel.unable_to_load")
            },
            payment_method: {
                required: Restaumatic_I18n.makeTranslationKey("orders.checkout.payment_method.required")
            },
            sending_order: Restaumatic_I18n.makeTranslationKey("orders.checkout.sending_order"),
            show_cart: Restaumatic_I18n.makeTranslationKey("orders.checkout.show_cart"),
            submit: {
                content: Restaumatic_I18n.makeTranslationKey("orders.checkout.submit.content"),
                loading_text: Restaumatic_I18n.makeTranslationKey("orders.checkout.submit.loading_text")
            },
            table: {
                amount: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.amount"),
                delivery: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.delivery"),
                description: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.description"),
                product: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.product"),
                subtotal: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.subtotal"),
                total: Restaumatic_I18n.makeTranslationKey("orders.checkout.table.total")
            },
            title: Restaumatic_I18n.makeTranslationKey("orders.checkout.title"),
            warning: {
                apt_number: {
                    content: Restaumatic_I18n.makeTranslationKey("orders.checkout.warning.apt_number.content"),
                    title: Restaumatic_I18n.makeTranslationKey("orders.checkout.warning.apt_number.title")
                }
            }
        },
        form: {
            address_data: Restaumatic_I18n.makeTranslationKey("orders.form.address_data"),
            agreement_html: Restaumatic_I18n.makeTranslationKey("orders.form.agreement_html"),
            check_marketing: {
                button: Restaumatic_I18n.makeTranslationKey("orders.form.check_marketing.button"),
                error: Restaumatic_I18n.makeTranslationKey("orders.form.check_marketing.error")
            },
            confirmation_code: {
                button: Restaumatic_I18n.makeTranslationKey("orders.form.confirmation_code.button"),
                button_label: Restaumatic_I18n.makeTranslationKey("orders.form.confirmation_code.button_label"),
                instructions: Restaumatic_I18n.makeTranslationKey("orders.form.confirmation_code.instructions")
            },
            correct_validation_errors: Restaumatic_I18n.makeTranslationKey("orders.form.correct_validation_errors"),
            delivery: {
                blank: Restaumatic_I18n.makeTranslationKey("orders.form.delivery.blank"),
                header: Restaumatic_I18n.makeTranslationKey("orders.form.delivery.header"),
                header_no_pickup: Restaumatic_I18n.makeTranslationKey("orders.form.delivery.header_no_pickup")
            },
            delivery_notes: Restaumatic_I18n.makeTranslationKey("orders.form.delivery_notes"),
            limited_available_delivery_times: Restaumatic_I18n.makeTranslationKey("orders.form.limited_available_delivery_times"),
            login: Restaumatic_I18n.makeTranslationKey("orders.form.login"),
            max_length: Restaumatic_I18n.makeTranslationKey("orders.form.max_length"),
            no_user: Restaumatic_I18n.makeTranslationKey("orders.form.no_user"),
            not_available_delivery_times: Restaumatic_I18n.makeTranslationKey("orders.form.not_available_delivery_times"),
            not_overlapping_delivery_times: Restaumatic_I18n.makeTranslationKey("orders.form.not_overlapping_delivery_times"),
            order_total: Restaumatic_I18n.makeTranslationKey("orders.form.order_total"),
            register: Restaumatic_I18n.makeTranslationKey("orders.form.register"),
            submit: {
                content: Restaumatic_I18n.makeTranslationKey("orders.form.submit.content"),
                loading_text: Restaumatic_I18n.makeTranslationKey("orders.form.submit.loading_text")
            },
            user: {
                blank: Restaumatic_I18n.makeTranslationKey("orders.form.user.blank"),
                header: Restaumatic_I18n.makeTranslationKey("orders.form.user.header")
            },
            user_data: Restaumatic_I18n.makeTranslationKey("orders.form.user_data")
        },
        order_summary: {
            address: Restaumatic_I18n.makeTranslationKey("orders.order_summary.address"),
            available_for_pickup_in: Restaumatic_I18n.makeTranslationKey("orders.order_summary.available_for_pickup_in"),
            client_data: Restaumatic_I18n.makeTranslationKey("orders.order_summary.client_data"),
            counter: {
                hours: Restaumatic_I18n.makeTranslationKey("orders.order_summary.counter.hours"),
                minutes: Restaumatic_I18n.makeTranslationKey("orders.order_summary.counter.minutes"),
                seconds: Restaumatic_I18n.makeTranslationKey("orders.order_summary.counter.seconds")
            },
            delivery_in: Restaumatic_I18n.makeTranslationKey("orders.order_summary.delivery_in"),
            info: Restaumatic_I18n.makeTranslationKey("orders.order_summary.info"),
            minutes: Restaumatic_I18n.makeTranslationKey("orders.order_summary.minutes"),
            modify: Restaumatic_I18n.makeTranslationKey("orders.order_summary.modify"),
            next_opening_hour: Restaumatic_I18n.makeTranslationKey("orders.order_summary.next_opening_hour"),
            payment: Restaumatic_I18n.makeTranslationKey("orders.order_summary.payment"),
            title: Restaumatic_I18n.makeTranslationKey("orders.order_summary.title"),
            user_note: Restaumatic_I18n.makeTranslationKey("orders.order_summary.user_note"),
            vat_id: Restaumatic_I18n.makeTranslationKey("orders.order_summary.vat_id")
        },
        show: {
            call_restaurant_if_late: Restaumatic_I18n.makeTranslationKey("orders.show.call_restaurant_if_late"),
            confirmation_info: Restaumatic_I18n.makeTranslationKey("orders.show.confirmation_info"),
            delivery_in: Restaumatic_I18n.makeTranslationKey("orders.show.delivery_in"),
            dont_close_this_page: Restaumatic_I18n.makeTranslationKey("orders.show.dont_close_this_page"),
            enjoy: Restaumatic_I18n.makeTranslationKey("orders.show.enjoy"),
            get_discounts: Restaumatic_I18n.makeTranslationKey("orders.show.get_discounts"),
            goto_homepage: Restaumatic_I18n.makeTranslationKey("orders.show.goto_homepage"),
            goto_order: Restaumatic_I18n.makeTranslationKey("orders.show.goto_order"),
            invite_friends: Restaumatic_I18n.makeTranslationKey("orders.show.invite_friends"),
            is_done: Restaumatic_I18n.makeTranslationKey("orders.show.is_done"),
            loyalty: Restaumatic_I18n.makeTranslationKey("orders.show.loyalty"),
            order_cancelled: Restaumatic_I18n.makeTranslationKey("orders.show.order_cancelled"),
            order_cancelled_message: Restaumatic_I18n.makeTranslationKey("orders.show.order_cancelled_message"),
            order_cancelled_message_po: Restaumatic_I18n.makeTranslationKey("orders.show.order_cancelled_message_po"),
            order_complete: Restaumatic_I18n.makeTranslationKey("orders.show.order_complete"),
            order_in_different_restaurant: Restaumatic_I18n.makeTranslationKey("orders.show.order_in_different_restaurant"),
            order_info: Restaumatic_I18n.makeTranslationKey("orders.show.order_info"),
            per_person: Restaumatic_I18n.makeTranslationKey("orders.show.per_person"),
            title: Restaumatic_I18n.makeTranslationKey("orders.show.title"),
            try_again: Restaumatic_I18n.makeTranslationKey("orders.show.try_again"),
            we_will_start_the_countdown: Restaumatic_I18n.makeTranslationKey("orders.show.we_will_start_the_countdown"),
            who_to_invite: Restaumatic_I18n.makeTranslationKey("orders.show.who_to_invite"),
            your_balance: Restaumatic_I18n.makeTranslationKey("orders.show.your_balance")
        }
    },
    payment_method: {
        card: {
            description: Restaumatic_I18n.makeTranslationKey("payment_method.card.description"),
            label: Restaumatic_I18n.makeTranslationKey("payment_method.card.label")
        },
        cash: {
            description: Restaumatic_I18n.makeTranslationKey("payment_method.cash.description"),
            label: Restaumatic_I18n.makeTranslationKey("payment_method.cash.label")
        },
        online: {
            description: Restaumatic_I18n.makeTranslationKey("payment_method.online.description"),
            label: Restaumatic_I18n.makeTranslationKey("payment_method.online.label")
        }
    },
    payments: {
        channel: {
            credit_card: Restaumatic_I18n.makeTranslationKey("payments.channel.credit_card")
        },
        error: Restaumatic_I18n.makeTranslationKey("payments.error"),
        form: {
            adyen: {
                header: Restaumatic_I18n.makeTranslationKey("payments.form.adyen.header")
            },
            card_info: Restaumatic_I18n.makeTranslationKey("payments.form.card_info"),
            caution: Restaumatic_I18n.makeTranslationKey("payments.form.caution"),
            change: Restaumatic_I18n.makeTranslationKey("payments.form.change"),
            dotpay: {
                header: Restaumatic_I18n.makeTranslationKey("payments.form.dotpay.header")
            },
            loading: Restaumatic_I18n.makeTranslationKey("payments.form.loading"),
            pay: Restaumatic_I18n.makeTranslationKey("payments.form.pay"),
            payment_info: Restaumatic_I18n.makeTranslationKey("payments.form.payment_info"),
            payment_rules: Restaumatic_I18n.makeTranslationKey("payments.form.payment_rules"),
            selected_payment_method: Restaumatic_I18n.makeTranslationKey("payments.form.selected_payment_method"),
            unavailable_header: Restaumatic_I18n.makeTranslationKey("payments.form.unavailable_header"),
            unavailable_info: Restaumatic_I18n.makeTranslationKey("payments.form.unavailable_info"),
            you_accept_the_rules_by_clicking: Restaumatic_I18n.makeTranslationKey("payments.form.you_accept_the_rules_by_clicking")
        },
        "new": {
            back_to_cart: Restaumatic_I18n.makeTranslationKey("payments.new.back_to_cart"),
            card_header: Restaumatic_I18n.makeTranslationKey("payments.new.card_header"),
            card_info: Restaumatic_I18n.makeTranslationKey("payments.new.card_info"),
            caution: Restaumatic_I18n.makeTranslationKey("payments.new.caution"),
            change: Restaumatic_I18n.makeTranslationKey("payments.new.change"),
            loading: Restaumatic_I18n.makeTranslationKey("payments.new.loading"),
            pay: Restaumatic_I18n.makeTranslationKey("payments.new.pay"),
            payment_info: Restaumatic_I18n.makeTranslationKey("payments.new.payment_info"),
            payment_rules: Restaumatic_I18n.makeTranslationKey("payments.new.payment_rules"),
            select_payment_method: Restaumatic_I18n.makeTranslationKey("payments.new.select_payment_method"),
            selected_payment_method: Restaumatic_I18n.makeTranslationKey("payments.new.selected_payment_method"),
            title: Restaumatic_I18n.makeTranslationKey("payments.new.title"),
            transfer_header: Restaumatic_I18n.makeTranslationKey("payments.new.transfer_header"),
            unavailable_header: Restaumatic_I18n.makeTranslationKey("payments.new.unavailable_header"),
            unavailable_info: Restaumatic_I18n.makeTranslationKey("payments.new.unavailable_info"),
            you_accept_the_rules_by_clicking: Restaumatic_I18n.makeTranslationKey("payments.new.you_accept_the_rules_by_clicking")
        },
        waiting: {
            check: Restaumatic_I18n.makeTranslationKey("payments.waiting.check"),
            header: Restaumatic_I18n.makeTranslationKey("payments.waiting.header"),
            i_didnt_pay: Restaumatic_I18n.makeTranslationKey("payments.waiting.i_didnt_pay"),
            i_paid: Restaumatic_I18n.makeTranslationKey("payments.waiting.i_paid"),
            info: Restaumatic_I18n.makeTranslationKey("payments.waiting.info"),
            not_payed: Restaumatic_I18n.makeTranslationKey("payments.waiting.not_payed"),
            pay: Restaumatic_I18n.makeTranslationKey("payments.waiting.pay"),
            please_pay: Restaumatic_I18n.makeTranslationKey("payments.waiting.please_pay"),
            redirect_info: Restaumatic_I18n.makeTranslationKey("payments.waiting.redirect_info"),
            title: Restaumatic_I18n.makeTranslationKey("payments.waiting.title"),
            wait_to_long: Restaumatic_I18n.makeTranslationKey("payments.waiting.wait_to_long"),
            we_are_waiting: Restaumatic_I18n.makeTranslationKey("payments.waiting.we_are_waiting")
        }
    },
    pizza: {
        custom_pizza: Restaumatic_I18n.makeTranslationKey("pizza.custom_pizza"),
        toppings: {
            "with": Restaumatic_I18n.makeTranslationKey("pizza.toppings.with"),
            without: Restaumatic_I18n.makeTranslationKey("pizza.toppings.without")
        }
    },
    promotions: {
        loyalty_promotion_dialog: {
            alt: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.alt"),
            button: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.button"),
            info_new_textile: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.info_new_textile"),
            info_textile: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.info_textile"),
            success_message: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.success_message"),
            success_message_new: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.success_message_new"),
            success_title: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.success_title"),
            title: Restaumatic_I18n.makeTranslationKey("promotions.loyalty_promotion_dialog.title")
        }
    },
    restaurants: {
        hours: {
            active: Restaumatic_I18n.makeTranslationKey("restaurants.hours.active"),
            closed: Restaumatic_I18n.makeTranslationKey("restaurants.hours.closed"),
            holidays: Restaumatic_I18n.makeTranslationKey("restaurants.hours.holidays"),
            inactive: Restaumatic_I18n.makeTranslationKey("restaurants.hours.inactive"),
            open: Restaumatic_I18n.makeTranslationKey("restaurants.hours.open")
        },
        menu: {
            add_to_cart: Restaumatic_I18n.makeTranslationKey("restaurants.menu.add_to_cart"),
            available_dish: Restaumatic_I18n.makeTranslationKey("restaurants.menu.available_dish"),
            available_dish_with_name: Restaumatic_I18n.makeTranslationKey("restaurants.menu.available_dish_with_name"),
            call_to_action: {
                subtitle_html: Restaumatic_I18n.makeTranslationKey("restaurants.menu.call_to_action.subtitle_html"),
                title: Restaumatic_I18n.makeTranslationKey("restaurants.menu.call_to_action.title")
            },
            closed_message: Restaumatic_I18n.makeTranslationKey("restaurants.menu.closed_message"),
            closed_message_hours: Restaumatic_I18n.makeTranslationKey("restaurants.menu.closed_message_hours"),
            drinks: Restaumatic_I18n.makeTranslationKey("restaurants.menu.drinks"),
            general_title: Restaumatic_I18n.makeTranslationKey("restaurants.menu.general_title"),
            homepage: Restaumatic_I18n.makeTranslationKey("restaurants.menu.homepage"),
            homepage_title: Restaumatic_I18n.makeTranslationKey("restaurants.menu.homepage_title"),
            info: Restaumatic_I18n.makeTranslationKey("restaurants.menu.info"),
            main_promotion: {
                title: Restaumatic_I18n.makeTranslationKey("restaurants.menu.main_promotion.title")
            },
            menu: Restaumatic_I18n.makeTranslationKey("restaurants.menu.menu"),
            not_found: Restaumatic_I18n.makeTranslationKey("restaurants.menu.not_found"),
            opens_in: Restaumatic_I18n.makeTranslationKey("restaurants.menu.opens_in"),
            other: Restaumatic_I18n.makeTranslationKey("restaurants.menu.other"),
            phone_hidden: Restaumatic_I18n.makeTranslationKey("restaurants.menu.phone_hidden"),
            phone_visible: Restaumatic_I18n.makeTranslationKey("restaurants.menu.phone_visible"),
            pie_choice: Restaumatic_I18n.makeTranslationKey("restaurants.menu.pie_choice"),
            price: Restaumatic_I18n.makeTranslationKey("restaurants.menu.price"),
            rating: Restaumatic_I18n.makeTranslationKey("restaurants.menu.rating"),
            restaurant_phone: Restaumatic_I18n.makeTranslationKey("restaurants.menu.restaurant_phone"),
            reviews: Restaumatic_I18n.makeTranslationKey("restaurants.menu.reviews"),
            sauces: Restaumatic_I18n.makeTranslationKey("restaurants.menu.sauces"),
            show_menu: Restaumatic_I18n.makeTranslationKey("restaurants.menu.show_menu"),
            show_more: Restaumatic_I18n.makeTranslationKey("restaurants.menu.show_more"),
            title: Restaumatic_I18n.makeTranslationKey("restaurants.menu.title"),
            toppings: Restaumatic_I18n.makeTranslationKey("restaurants.menu.toppings"),
            unavailable_dish: Restaumatic_I18n.makeTranslationKey("restaurants.menu.unavailable_dish"),
            unavailable_dish_with_name: Restaumatic_I18n.makeTranslationKey("restaurants.menu.unavailable_dish_with_name")
        },
        menu_sidebar: {
            phone_hidden: Restaumatic_I18n.makeTranslationKey("restaurants.menu_sidebar.phone_hidden"),
            phone_visible: Restaumatic_I18n.makeTranslationKey("restaurants.menu_sidebar.phone_visible"),
            show_more: Restaumatic_I18n.makeTranslationKey("restaurants.menu_sidebar.show_more")
        },
        select: {
            button_change: Restaumatic_I18n.makeTranslationKey("restaurants.select.button_change"),
            button_hide: Restaumatic_I18n.makeTranslationKey("restaurants.select.button_hide"),
            button_select: Restaumatic_I18n.makeTranslationKey("restaurants.select.button_select"),
            button_show: Restaumatic_I18n.makeTranslationKey("restaurants.select.button_show"),
            error_address: Restaumatic_I18n.makeTranslationKey("restaurants.select.error_address"),
            header_all: Restaumatic_I18n.makeTranslationKey("restaurants.select.header_all"),
            header_deliver: Restaumatic_I18n.makeTranslationKey("restaurants.select.header_deliver"),
            header_others: Restaumatic_I18n.makeTranslationKey("restaurants.select.header_others"),
            title_find: Restaumatic_I18n.makeTranslationKey("restaurants.select.title_find"),
            title_select: Restaumatic_I18n.makeTranslationKey("restaurants.select.title_select")
        },
        widgets: {
            cart: {
                checkout: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.checkout"),
                clear: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.clear"),
                clear_confirmation: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.clear_confirmation"),
                cost_info: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.cost_info"),
                delivery: {
                    back: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.delivery.back"),
                    cost: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.delivery.cost"),
                    header: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.delivery.header")
                },
                empty: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.empty"),
                hide: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.hide"),
                hide_and_continue: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.hide_and_continue"),
                loading_text: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.loading_text"),
                name: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.name"),
                no_coupon_items: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.no_coupon_items"),
                opening_hour: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.opening_hour"),
                remove: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.remove"),
                unavailable: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart.unavailable")
            },
            cart_items: {
                coupon_item: {
                    add: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart_items.coupon_item.add"),
                    placeholder: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart_items.coupon_item.placeholder"),
                    remove: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart_items.coupon_item.remove")
                },
                remove: Restaumatic_I18n.makeTranslationKey("restaurants.widgets.cart_items.remove")
            }
        }
    },
    theme_defaults: {
        cart: {
            edit_item: Restaumatic_I18n.makeTranslationKey("theme_defaults.cart.edit_item"),
            empty: Restaumatic_I18n.makeTranslationKey("theme_defaults.cart.empty"),
            inactive_promotions: Restaumatic_I18n.makeTranslationKey("theme_defaults.cart.inactive_promotions"),
            name: Restaumatic_I18n.makeTranslationKey("theme_defaults.cart.name"),
            to_checkout: Restaumatic_I18n.makeTranslationKey("theme_defaults.cart.to_checkout")
        },
        checkout: {
            cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.checkout.cart"),
            change_cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.checkout.change_cart"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.checkout.title")
        },
        consents: {
            description: Restaumatic_I18n.makeTranslationKey("theme_defaults.consents.description"),
            form: {
                email: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.consents.form.email.label")
                },
                phone: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.consents.form.phone.label")
                },
                submit: Restaumatic_I18n.makeTranslationKey("theme_defaults.consents.form.submit")
            },
            success_message: Restaumatic_I18n.makeTranslationKey("theme_defaults.consents.success_message")
        },
        contact: {
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.contact.title")
        },
        creator: {
            add_to_cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.add_to_cart"),
            base_pizza: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.base_pizza"),
            change_toppings: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.change_toppings"),
            dough: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.dough"),
            hide: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.hide"),
            pizza_1st_half: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.pizza_1st_half"),
            pizza_2nd_half: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.pizza_2nd_half"),
            pizza_size: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.pizza_size"),
            split_pizza: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.split_pizza"),
            stepper: {
                decrease: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.stepper.decrease"),
                increase: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.stepper.increase")
            },
            topping_unavailable_in_size: Restaumatic_I18n.makeTranslationKey("theme_defaults.creator.topping_unavailable_in_size")
        },
        delivery: {
            form: {
                submit: Restaumatic_I18n.makeTranslationKey("theme_defaults.delivery.form.submit")
            }
        },
        dish_creator: {
            add_to_cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.add_to_cart"),
            cancel: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.cancel"),
            choose_many: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.choose_many"),
            choose_one: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.choose_one"),
            correct_errors: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.correct_errors"),
            side: {
                default_name: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.side.default_name"),
                existing_name: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.side.existing_name"),
                too_many_selected: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.side.too_many_selected")
            },
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.title"),
            total: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_creator.total")
        },
        dish_label: {
            free_toppings: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_label.free_toppings"),
            "new": Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_label.new"),
            recommended: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_label.recommended"),
            special: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_label.special"),
            unavailable: Restaumatic_I18n.makeTranslationKey("theme_defaults.dish_label.unavailable")
        },
        hours: {
            delivery_hours: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.delivery_hours"),
            holidays: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.holidays"),
            is_active_now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_active_now"),
            is_close: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_close"),
            is_close_now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_close_now"),
            is_closed_now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_closed_now"),
            is_inactive_now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_inactive_now"),
            is_open: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_open"),
            is_open_now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.is_open_now"),
            now: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.now"),
            online_hours: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.online_hours"),
            online_orders: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.online_orders"),
            online_orders_condensed: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.online_orders_condensed"),
            online_orders_condensed_today: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.online_orders_condensed_today"),
            opening_hours: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.opening_hours"),
            order_online: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.order_online"),
            ordering_hours: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.ordering_hours"),
            ordering_hours_general: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.ordering_hours_general"),
            phone_hours: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.phone_hours"),
            phone_orders: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.phone_orders"),
            phone_orders_condensed: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.phone_orders_condensed"),
            phone_orders_condensed_today: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.phone_orders_condensed_today"),
            today: Restaumatic_I18n.makeTranslationKey("theme_defaults.hours.today")
        },
        login_modal: {
            button_facebook: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.button_facebook"),
            button_login: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.button_login"),
            button_register: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.button_register"),
            email_label: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.email_label"),
            email_placeholder: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.email_placeholder"),
            error_message: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.error_message"),
            forgot_password: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.forgot_password"),
            password_label: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.password_label"),
            password_placeholder: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.password_placeholder"),
            remember_me: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.remember_me"),
            subtitle: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.subtitle"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.login_modal.title")
        },
        menu: {
            add_to_cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.add_to_cart"),
            allergens: {
                content_md: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.content_md"),
                label: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.label"),
                labeling: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.labeling"),
                names: {
                    Celery: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Celery"),
                    Crustaceans: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Crustaceans"),
                    Eggs: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Eggs"),
                    Fish: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Fish"),
                    Gluten: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Gluten"),
                    Lupin: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Lupin"),
                    Milk: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Milk"),
                    Molluscs: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Molluscs"),
                    Mustard: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Mustard"),
                    Nuts: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Nuts"),
                    Peanuts: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Peanuts"),
                    Sesame: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Sesame"),
                    Soybeans: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.Soybeans"),
                    SulphurDioxide: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.allergens.names.SulphurDioxide")
                }
            },
            change_toppings: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.change_toppings"),
            custom_pizza: {
                creator_btn: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.custom_pizza.creator_btn"),
                creator_btn_standalone: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.custom_pizza.creator_btn_standalone"),
                description: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.custom_pizza.description"),
                title: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.custom_pizza.title")
            },
            description: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.description"),
            dough: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.dough"),
            drinks: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.drinks"),
            edit_pizza: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.edit_pizza"),
            nav: {
                title: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.nav.title")
            },
            no_photo: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.no_photo"),
            offers: {
                close: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.close"),
                description: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.description"),
                hide: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.hide"),
                offer: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.offer"),
                show: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.show"),
                title: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.offers.title")
            },
            pizza: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.pizza"),
            pizza_sizes: {
                available: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.pizza_sizes.available"),
                unavailable: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.pizza_sizes.unavailable")
            },
            price: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.price"),
            price_from: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.price_from"),
            reveal_phone: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.reveal_phone"),
            show_dish_types: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.show_dish_types"),
            split_pizza: {
                creator_btn: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.split_pizza.creator_btn"),
                description: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.split_pizza.description"),
                title: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.split_pizza.title")
            },
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.menu.title")
        },
        modal: {
            close: Restaumatic_I18n.makeTranslationKey("theme_defaults.modal.close"),
            confirm: Restaumatic_I18n.makeTranslationKey("theme_defaults.modal.confirm")
        },
        order_summary: {
            back: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.back"),
            cart: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.cart"),
            delivery: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.delivery"),
            price: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.price"),
            product: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.product"),
            quantity: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.quantity"),
            total: Restaumatic_I18n.makeTranslationKey("theme_defaults.order_summary.total")
        },
        promotion_popover: {
            availability: Restaumatic_I18n.makeTranslationKey("theme_defaults.promotion_popover.availability")
        },
        register_modal: {
            button_login: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.button_login"),
            button_register: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.button_register"),
            email_label: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.email_label"),
            email_placeholder: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.email_placeholder"),
            password_label: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.password_label"),
            password_placeholder: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.password_placeholder"),
            subtitle: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.subtitle"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.register_modal.title")
        },
        reservation: {
            for_today: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.for_today"),
            form: {
                email: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.email.label")
                },
                full_name: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.full_name.label")
                },
                num_people: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.num_people.label")
                },
                phone: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.phone.label")
                },
                reservation_date: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.reservation_date.label")
                },
                restaurant: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.restaurant.label")
                },
                submit: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.submit"),
                user_notes: {
                    label: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.form.user_notes.label")
                }
            },
            subtitle: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.subtitle"),
            subtitle_small: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.subtitle_small"),
            success_message: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.success_message"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.reservation.title")
        },
        select_restaurant: {
            check_delivery: Restaumatic_I18n.makeTranslationKey("theme_defaults.select_restaurant.check_delivery"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.select_restaurant.title")
        },
        summary: {
            additional_information: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.additional_information"),
            contact_us: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.contact_us"),
            online_order_problem: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.online_order_problem"),
            order_accepted: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.order_accepted"),
            order_cancelled: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.order_cancelled"),
            payment_will_be_returned: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.payment_will_be_returned"),
            time_to_delivery: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.time_to_delivery"),
            title: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.title"),
            try_again: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.try_again"),
            waiting_for_confirmation: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.waiting_for_confirmation"),
            waiting_for_dispatch: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.waiting_for_dispatch"),
            waiting_for_payment: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.waiting_for_payment"),
            waiting_for_payment_message: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.waiting_for_payment_message"),
            we_are_sorry: Restaumatic_I18n.makeTranslationKey("theme_defaults.summary.we_are_sorry")
        },
        theme: {
            informations: Restaumatic_I18n.makeTranslationKey("theme_defaults.theme.informations"),
            restaurants: Restaumatic_I18n.makeTranslationKey("theme_defaults.theme.restaurants")
        },
        user: {
            register: Restaumatic_I18n.makeTranslationKey("theme_defaults.user.register"),
            sign_in: Restaumatic_I18n.makeTranslationKey("theme_defaults.user.sign_in")
        },
        users: {
            account: Restaumatic_I18n.makeTranslationKey("theme_defaults.users.account"),
            login: Restaumatic_I18n.makeTranslationKey("theme_defaults.users.login"),
            logout: Restaumatic_I18n.makeTranslationKey("theme_defaults.users.logout"),
            register: Restaumatic_I18n.makeTranslationKey("theme_defaults.users.register")
        }
    },
    time_range: {
        closed: Restaumatic_I18n.makeTranslationKey("time_range.closed")
    },
    topping_type: {
        cheeses: Restaumatic_I18n.makeTranslationKey("topping_type.cheeses"),
        meat: Restaumatic_I18n.makeTranslationKey("topping_type.meat"),
        meet: Restaumatic_I18n.makeTranslationKey("topping_type.meet"),
        sauces: Restaumatic_I18n.makeTranslationKey("topping_type.sauces"),
        spices: Restaumatic_I18n.makeTranslationKey("topping_type.spices"),
        vegetables: Restaumatic_I18n.makeTranslationKey("topping_type.vegetables")
    },
    validations: {
        enter_date: Restaumatic_I18n.makeTranslationKey("validations.enter_date"),
        invalid_email: Restaumatic_I18n.makeTranslationKey("validations.invalid_email"),
        invalid_phone: Restaumatic_I18n.makeTranslationKey("validations.invalid_phone")
    }
};
module.exports = {
    t: t
};
//# sourceMappingURL=index.js.map
